import { Injectable } from '@angular/core';
import { ApiService } from '@services/api.service';

@Injectable({
    providedIn: 'root'
})
export class VisitorMedicalConsultationService extends ApiService {
    getByVisitors(data: any) {
        return super.post('/visitors-medical-consultation/visitors', data);
    }

    getCountDayAndFuture(id: number) {
        return super.get("/visitors-medical-consultation/count/day-future/" + id);
    }

    create(data: any) {
        return super.post('/visitors-medical-consultation/create', data);
    }

    update(data: any) {
        return super.put('/visitors-medical-consultation/update', data);
    }

    delete(id: number) {
        return super.delete('/visitors-medical-consultation/' + id);
    }
}
